/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IERC20LikeV3, IERC20LikeV3Interface } from "../IERC20LikeV3";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IERC20LikeV3__factory {
  static readonly abi = _abi;
  static createInterface(): IERC20LikeV3Interface {
    return new utils.Interface(_abi) as IERC20LikeV3Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IERC20LikeV3 {
    return new Contract(address, _abi, signerOrProvider) as IERC20LikeV3;
  }
}
